import PureLoadable from 'react-17-pure-loadable';

export default PureLoadable({
  loader: () => import('./ExplainFeatureButton.jsx'),
  displayName: 'ExplainFeatureButton',
});
